module.exports = __webpack_public_path__ + "img/IMG_1231_L_Foamcore_MockedUp.00bb35f6.jpg";